var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _vm.importingClients
              ? _c("p", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "application.actions.import.importAllClientsBody"
                        )
                      ) +
                      "\n      "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("application.actions.import.enterMissingInformation")
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.importingClients
              ? _c("p", { staticClass: "bold" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "application.actions.import.couldTakeSeveralMinNote"
                        )
                      ) +
                      "\n      "
                  ),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("filogix-details-form", {
            attrs: {
              "show-equifax": false,
              "only-show-profile-number-field": _vm.onlyShowProfileNumberField,
            },
            model: {
              value: _vm.filogixDetailsLocal,
              callback: function ($$v) {
                _vm.filogixDetailsLocal = $$v
              },
              expression: "filogixDetailsLocal",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }